//using toast service as alert
import toastServices from "@/services/toast";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { DeviceDetection } from "../game/src/helpers/deviceDetection";

/**
 *#Access user location
 *##Returns user latitude and longitude
 * ###Dependencies: toastService
 * Must be used in async/await (try-catch) or then/catch
 * @returns {Promise<Position>}
 *
 */
// function getUserLocation() {
//     return new Promise((resolve) =>
//         navigator.geolocation.getCurrentPosition((position) => {
//             const latitude = position.coords.latitude;
//             const longitude = position.coords.longitude;
//             //Returning user coords
//             resolve({latitude: latitude, longitude: longitude});
//         }, (error) => {
//             //Handling errors
//             switch (error.code) {
//                 case error.PERMISSION_DENIED:
//                     toastServices.typeError("User denied the request for Geolocation.")
//                     break;
//                 case error.POSITION_UNAVAILABLE:
//                     toastServices.typeError("Location information is unavailable.")
//                     break;
//                 case error.TIMEOUT:
//                     toastServices.typeError("The request to get user location timed out.")
//                     break;
//                 case error.UNKNOWN_ERROR:
//                     toastServices.typeError("An unknown error occurred.")
//                     break;
//             }
//         })
//     );
// }
function getUserLocation() {
  return new Promise((resolve, reject) => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          //Returning user coords
          resolve({ latitude: latitude, longitude: longitude });
        },
        (error) => {
          let text = "";
          reject(error);
          switch (error.code) {
            case 0: {
              // UNKNOWN_ERROR
              text = error.message || "An unknown error occurred.";
              break;
            }
            case 1: {
              // PERMISSION_DENIED
              if (DeviceDetection.isDesktop()) {
                if (DeviceDetection.isSafari()) {
                  text =
                    "You've decided not to share your position, but if you change your mind:" +
                    "<br>• click on the Safari menu in the upper left of your display (next to the Apple  menu)." +
                    "<br>• Choose Preferences > Websites tab > Location." +
                    "<br>• Tap on this website and choose: Allow." +
                    "<br>• Then refresh the page.";
                } else if (DeviceDetection.isChrome()) {
                  text =
                    "You've decided not to share your position, but if you change your mind:" +
                    "<br>• On your computer, open Chrome." +
                    "<br>• At the top right, click More > Settings." +
                    "<br>• Click Privacy and security > Site Settings." +
                    "<br>• Click Location." +
                    "<br>• Delete this website from 'Not allowed to see your location' section.";
                  text = DeviceDetection.isMac()
                    ? text +
                      "<br>If the first solution doesn't work, You need to go into:<br>• System Preferences > Security & Privacy > Privacy tab, and make sure Chrome is on the Enable Location Services list."
                    : text;
                } else if (DeviceDetection.isFirefox()) {
                  text =
                    "You've decided not to share your position, but if you change your mind, refresh the page.";
                  text = DeviceDetection.isMac()
                    ? text +
                      "<br>If the first solution doesn't work, You need to go into:<br>• System Preferences > Security & Privacy > Privacy tab, and make sure Firefox is on the Enable Location Services list."
                    : text;
                } else {
                  text = error.message;
                }
              } else if (DeviceDetection.isAndroid()) {
                if (DeviceDetection.isChrome()) {
                  text =
                    "First, Check that your phone has location enabled. Go to Settings -> Connections -> Location and enable if necessary." +
                    "<br>If the first solution doesn't work:" +
                    "<br>• When Chrome is open, click the dots in the upper right corner to open up the context menu." +
                    "<br>• Go to Settings -> Site Settings -> Location" +
                    '<br>• Make sure the "Location" switch is enabled' +
                    '<br>• Check the "Blocked" and "Allowed" lists by tapping them. If Treys is blocked, remove it by selecting it and tapping "Clear & Reset". ' +
                    `<br>• Go back to Treys. Now the app asks for your permission to use your device's location. Select "Allow". `;
                } else if (
                  !DeviceDetection.isChrome() &&
                  !DeviceDetection.isFirefox()
                ) {
                  text =
                    "First, Check that your phone has location enabled. Go to Settings -> Connections -> Location and enable if necessary." +
                    "<br>If the first solution doesn't work:" +
                    "<br>• When the Internet browser is open, click the dots in the upper right corner to open up the context menu." +
                    `<br>• Select Settings -> Privacy -> Delete personal data. Select only "Location access data" and click Delete. This resets your browser's location access settings.` +
                    `<br>• Go back to Treys. Now the app asks for your permission to use your device's location. Select "Allow". `;
                } else {
                  text = error.message;
                }
              } else if (DeviceDetection.isiPhone()) {
                if (DeviceDetection.isSafari()) {
                  text =
                    `<br>• Go to Settings -> General -> Restrictions -> Privacy -> Location Services` +
                    `<br>• Make sure both "Allow Changes" and "Location Services" are enabled` +
                    `<br>• Scroll down, find "Safari Websites", tap on it and allow location services "While using the app"` +
                    `<br>• Go back to Treys. It should be working now.`;
                } else {
                  text = error.message;
                }
              }
              break;
            }
            case 2: {
              // POSITION_UNAVAILABLE
              if (DeviceDetection.isDesktop()) {
                if (DeviceDetection.isSafari()) {
                  text =
                    "You need to go into System Preferences > Security & Privacy > Privacy tab, and make sure Safari is on the Enable Location Services list.";
                } else if (DeviceDetection.isChrome()) {
                  text =
                    "There is a problem in getting location. We suggest you turn your VPN on.";
                } else {
                  text = error.message;
                }
              } else {
                text = error.message;
              }
              break;
            }
            case 3: {
              // UTIMEOUT
              text =
                error.message || "The request to get user location timed out.";
              break;
            }
            default: {
              text = error.message;
              break;
            }
          }
          Swal.fire({
            html: text,
            showCancelButton: false,
            showConfirmButton: false,
            color: "#ffffff",
            customClass: {

              htmlContainer: "sweet-alert-container",
              icon: "sweet-alert-icon",
              // Add the custom class for the background here
              popup: "sweet-alert-main-container",
            },
            icon: "info",
          });
        }
      );
    } else {
      toastServices.typeError("Make sure your browser supports geolocation.");
      reject(error);
    }
  });
}
export default {
  //exporting it as default
  getUserLocation,
};
